import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'
import { IconButton } from '@ui/components/Button'
import { CloseIcon } from '@ui/icons/Close.icon'

import { useWindowResize } from '@utils/domUtils'

import styles from './Alert.module.scss'

interface AlertProps {
  text: string
  renderLeft?: React.ReactNode
  renderRight?: React.ReactNode
  onClose?(): void
}

export const Alert: React.FC<AlertProps> = (props) => {
  const isMobile = useWindowResize()
  return isMobile ? <MobileAlert {...props} /> : <DesktopAlert {...props} />
}

const DesktopAlert: React.FC<AlertProps> = (props) => {
  const { text, renderLeft, renderRight } = props

  return (
    <div className={styles.alert}>
      <AlertContent>
        <div>{renderLeft}</div>
        {text && <Body1 isParagraph>{text}</Body1>}
        <div>{renderRight}</div>
      </AlertContent>
      <div className={styles.close}>
        <NoteCloseButton {...props} />
      </div>
    </div>
  )
}

const MobileAlert: React.FC<AlertProps> = (props) => {
  const { text, renderRight } = props

  const { t } = useTranslation()

  return (
    <div className={styles.alert}>
      <AlertContent>
        <div className={styles.close}>
          <NoteCloseButton {...props} />
        </div>
        <div className={styles.text}>
          {text && <Body1 medium>{text}</Body1>}
          <Body1 isParagraph>{t('Tap for more details')}</Body1>
        </div>
      </AlertContent>
      <div>{renderRight}</div>
    </div>
  )
}

const AlertContent: React.FC<PropsWithChildren> = (props) => {
  const { children } = props

  return <div className={styles.content}>{children}</div>
}

const NoteCloseButton: React.FC<AlertProps> = (props) => {
  const { onClose } = props
  return <IconButton.Ghost icon={CloseIcon} onClick={onClose} />
}
